import React, { useState, useEffect, useRef } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import Button from '@mui/material/Button';
import { GetEmbedConfig } from '../../../api/reports';
import { useQuery } from '@tanstack/react-query';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';

function PowerBi({ params, workspaceId, reportId, groupId, datasetId, npnUpdateDetails }) {
  //component state
  const parsedParams = params ? [JSON.parse(params)] : null;
  const [paramsState, setParamsState] = useState({});
  const [updateDetails, setUpdateDetails] = useState(null);
  const [version, setVersion] = useState(1);
  const [previousReportId, setPreviousReportId] = useState(null);

  useEffect(() => {
    if (reportId !== previousReportId) {
      setPreviousReportId(reportId);

      if (previousReportId !== null) setUpdateDetails(null);
    }
  }, [reportId]);

  //UseQuery Hooks
  const embedReturn = useQuery({
    queryKey: ['embedConfig', updateDetails, reportId],
    queryFn: () =>
      GetEmbedConfig({
        workspaceId: workspaceId,
        reportId: reportId,
        updateDetails: updateDetails,
        groupId: groupId,
        datasetId: datasetId,
      })(),
    enabled: updateDetails !== null && previousReportId === reportId,
    gcTime: 0,
  });
  //Effects
  useEffect(() => {
    if (npnUpdateDetails) {
      setUpdateDetails(npnUpdateDetails);
    } else if (parsedParams.filter((e) => e.ParameterName === 'NPN').length > 0) {
      setUpdateDetails([
        { name: 'NPN', newValue: '' },
        { name: 'ShowDownlines', newValue: false },
      ]);
    }
  }, [npnUpdateDetails]);
  useEffect(() => {
    updateVersion();
  }, [embedReturn.data]);
  //Event Handlers
  const handleUpdateParamsState = (key, value) => {
    let tempParamsState = paramsState;
    tempParamsState[key] = value;
    setParamsState(tempParamsState);
  };
  const handleSubmitParams = () => {
    let tempUpdateDetails = [];
    Object.keys(paramsState).map((key, index) => {
      tempUpdateDetails = [
        ...tempUpdateDetails.filter((e) => e.name !== key),
        { name: key, newValue: paramsState[key] },
      ];
    });
    setUpdateDetails(tempUpdateDetails);
  };
  const updateVersion = () => {
    setVersion(version + 1);
  };

  console.log(parsedParams, 'params');
  console.log(datasetId, 'dataset-powerbi');
  if (!parsedParams) return <></>;
  if (embedReturn.isLoading)
    return (
      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center' }}>
        <LoadingIndicator size={'sm'} style={{ marginTop: 'auto', marginBottom: 'auto' }} />
      </div>
    );
  if (embedReturn.status === 'error') return <h1>{JSON.stringify(embedReturn.error)}</h1>;
  if (embedReturn.data?.error)
    return (
      <p style={{ textAlign: 'center', margin: '10%', fontSize: 'x-large', width: '100%' }}>
        {embedReturn.data.error}
      </p>
    );
  return (
    <>
      {parsedParams[0].ParameterName !== 'NPN' && (
        <div className="container">
          <div className="row mt-4">
            {parsedParams.map((param, index) => {
              switch (param.ParameterType) {
                case 'SingleText':
                  return (
                    <div key={param.ParameterName} className="col-3 d-flex justify-content-start align-items-center">
                      <input
                        onBlur={(e) => {
                          handleUpdateParamsState(param.ParameterName, e.target.value);
                        }}
                        style={{ height: '2.5em' }}
                        className="form-control form-control-sm ml-3 w-75"
                        type="text"
                        placeholder={param.ParameterTitle}
                        aria-label="Search"
                      />
                    </div>
                  );
                default:
                  break;
              }
            })}
            <div className="col-1 justify-content-start align-items-center">
              <Button
                onClick={() => {
                  handleSubmitParams();
                }}
                variant="contained"
                className="btn btn-primary"
              >
                View
              </Button>
            </div>
          </div>
        </div>
      )}
      {updateDetails !== null && (
        <PowerBIEmbed
          key={version}
          embedConfig={{
            //make type dynamic to support dashboards & reports?? - would need to make id, embedUrl, etc. dynamic as well

            type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
            id: embedReturn.data?.embedReports[0].reportId,
            embedUrl: embedReturn?.data?.embedReports[0].embedUrl,
            accessToken: embedReturn?.data?.embedToken.token,
            tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
            settings: {
              filterPaneEnabled: true,
              navContentPaneEnabled: true,
              background: models.BackgroundType.Transparent,
              // START Report specific settings
              layoutType: models.LayoutType.Custom,
              customLayout: {
                displayOption: models.DisplayOption.FitToWidth,
              },
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
              },
            },
          }}
          eventHandlers={
            new Map([
              [
                'loaded',
                function () {
                  console.log('Report loaded');
                },
              ],
              [
                'rendered',
                function () {
                  console.log('Report rendered');
                },
              ],
              [
                'error',
                function (event) {
                  console.log(event.detail);
                },
              ],
            ])
          }
          cssClassName={'Embed-Container'}
          getEmbeddedComponent={(embeddedReport) => {
            window.report = embeddedReport;
          }}
        />
      )}
    </>
  );
}

export default PowerBi;
